import React, { JSX } from 'react'
import './Spinner.css'

export const Spinner: React.FC = (): JSX.Element => {
  return (
    <div className="upload-spinner" data-testid="upload-spinner">
      <div className="circle-spinner">
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  )
}
